import styled from 'styled-components';
import { PollBar, Question } from '@elfsight/icons';
import { Button, type ButtonProps } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { useTranslation } from 'react-i18next';
import { ViewType } from '../../types';
import { useVoteContext } from '../providers';

export function PreviewViewToggle() {
  const { editMode, renderThumbnailMode, accentColor } = useSettings();
  const { viewType, setViewType } = useVoteContext();
  const { t } = useTranslation();

  const commonProps: (active: boolean) => ButtonProps = (active) => ({
    verticalPadding: 6,
    horizontalPadding: 12,
    font: {
      fontWeight: 700,
      fontSize: 13
    },
    color: `rgba(255, 255, 255, ${active ? 1 : 0.5})`,
    overlayOpacityOnHover: 0,
    variants: {
      initial: {
        color: `rgba(17, 17, 17, ${active ? 0.7 : 0.5})`
      },
      hover: {
        zIndex: 1,
        color: 'rgba(17, 17, 17, 0.7)'
      }
    },
    style: {
      transition: 'background-color 0.1s ease-out'
    }
  });

  if (!editMode || renderThumbnailMode) {
    return;
  }

  return (
    <Container>
      <Button
        {...commonProps(viewType === ViewType.VoteView)}
        iconLeft={Question}
        onClick={() => setViewType(ViewType.VoteView)}
        focusColor={accentColor}
      >
        {t('Vote View')}
      </Button>
      <Button
        {...commonProps(viewType === ViewType.ResultView)}
        iconLeft={PollBar}
        onClick={() => setViewType(ViewType.ResultView)}
        focusColor={accentColor}
      >
        {t('Result View')}
      </Button>
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  top: 20px;
  padding: 2px;
  border-radius: 6px;
  background: rgba(242, 242, 242, 0.9);
`;
